import { Component, computed, input } from '@angular/core';
import { BadgeModule } from '@openng/optimus-ui/badge';
import { DealStatus, DealStatusLabels } from '../../enums/deal-status.enum';

type BadgeSeverity = 'info' | 'success' | 'warn' | 'danger' | 'secondary' | 'contrast' | null | undefined;

@Component({
  selector: 'lib-sign-status-badge',
  imports: [BadgeModule],
  standalone: true,
  templateUrl: './sign-status-badge.component.html',
  styleUrl: './sign-status-badge.component.scss'
})
export class SignStatusBadgeComponent {
  status = input.required<string>();
  class = input<BadgeSeverity>();
  showValue = input<boolean>(true);
  count = input<number | null>(null);

  private statusInUpperCase = computed(() => this.status().toUpperCase());
  private DealStatusLabels = DealStatusLabels;

  getBadgeValue(): string {
    if (this.count() !== null) return String(this.count());
    if (!this.status()) return '';
    return this.DealStatusLabels[this.statusInUpperCase() as DealStatus];
  }

  getBadgeSeverity(): BadgeSeverity {
    if (!this.status()) return undefined;
    if (this.class()) return this.class()!;

    switch (this.statusInUpperCase()) {
      case DealStatus.Selection:
        return 'secondary';
      case DealStatus.ContractReady:
        return 'info';
      case DealStatus.PendingOffer:
        return 'warn';
      case DealStatus.Cancelled:
        return 'danger';
      case DealStatus.FinalSale:
        return undefined;
      case DealStatus.UnderContract:
        return 'success';
      default:
        return undefined;
    }
  }
}
